export const AVATAR_DEFAULT_DNA = {
	style: 'circle',
	bgColor: 'blue',
	skin: 'light',
	top: 'shortHair',
	hairColor: 'brown',
	accessories: 'none',
	facialHair: 'none',
	facialHairColor: 'brown',
	clothes: 'shirt',
	clothesColor: 'blue',
	eyes: 'default',
	eyebrow: 'default',
	mouth: 'smile',
};

export const AVATAR_OPTIONS = {
	style: [
		{ value: 'circle', label: 'Коло' },
		{ value: 'transparent', label: 'Прозорий' },
	],
	bgColor: [
		{ value: 'blue', label: 'Блакитний' },
		{ value: 'mint', label: 'М’ятний' },
		{ value: 'lavender', label: 'Лавандовий' },
		{ value: 'peach', label: 'Персиковий' },
		{ value: 'sand', label: 'Пісочний' },
		{ value: 'gray', label: 'Сірий' },
		{ value: 'green', label: 'Зелений' },
		{ value: 'red', label: 'Червоний' },
	],
	skin: [
		{ value: 'tanned', label: 'Засмаглий' },
		{ value: 'yellow', label: 'Жовтуватий' },
		{ value: 'pale', label: 'Блідий' },
		{ value: 'light', label: 'Світлий' },
		{ value: 'brown', label: 'Коричневий' },
		{ value: 'darkBrown', label: 'Темно-коричневий' },
		{ value: 'black', label: 'Темний' },
	],
	top: [
		{ value: 'noHair', label: 'Без волосся' },
		{ value: 'shortHair', label: 'Коротке' },
		{ value: 'longHair', label: 'Довге' },
		{ value: 'hat', label: 'Шапка' },
		{ value: 'eyepatch', label: 'Пов’язка' },
		{ value: 'hijab', label: 'Хіджаб' },
		{ value: 'turban', label: 'Тюрбан' },
	],
	hairColor: [
		{ value: 'auburn', label: 'Мідний' },
		{ value: 'black', label: 'Чорний' },
		{ value: 'blonde', label: 'Блонд' },
		{ value: 'brown', label: 'Каштановий' },
		{ value: 'pastel', label: 'Пастельний' },
		{ value: 'platinum', label: 'Платиновий' },
		{ value: 'red', label: 'Рудий' },
		{ value: 'gray', label: 'Сивий' },
	],
	accessories: [
		{ value: 'none', label: 'Без аксесуарів' },
		{ value: 'kurt', label: 'Накладки' },
		{ value: 'prescription01', label: 'Окуляри 1' },
		{ value: 'prescription02', label: 'Окуляри 2' },
		{ value: 'round', label: 'Круглі' },
		{ value: 'sunglasses', label: 'Сонцезахисні' },
		{ value: 'wayfarers', label: 'Вейфарери' },
	],
	facialHair: [
		{ value: 'none', label: 'Без бороди' },
		{ value: 'light', label: 'Легка борода' },
		{ value: 'medium', label: 'Середня борода' },
		{ value: 'majestic', label: 'Пишна борода' },
		{ value: 'fancy', label: 'Вуса' },
		{ value: 'magnum', label: 'Великі вуса' },
	],
	facialHairColor: [
		{ value: 'auburn', label: 'Мідний' },
		{ value: 'black', label: 'Чорний' },
		{ value: 'blonde', label: 'Блонд' },
		{ value: 'brown', label: 'Каштановий' },
		{ value: 'pastel', label: 'Пастельний' },
		{ value: 'platinum', label: 'Платиновий' },
		{ value: 'red', label: 'Рудий' },
		{ value: 'gray', label: 'Сивий' },
	],
	clothes: [
		{ value: 'blazer', label: 'Піджак' },
		{ value: 'sweater', label: 'Светр' },
		{ value: 'shirt', label: 'Футболка' },
		{ value: 'hoodie', label: 'Худі' },
		{ value: 'overall', label: 'Комбінезон' },
	],
	clothesColor: [
		{ value: 'black', label: 'Чорний' },
		{ value: 'blue', label: 'Синій' },
		{ value: 'gray', label: 'Сірий' },
		{ value: 'heather', label: 'Меланж' },
		{ value: 'pastel', label: 'Пастельний' },
		{ value: 'pink', label: 'Рожевий' },
		{ value: 'red', label: 'Червоний' },
		{ value: 'white', label: 'Білий' },
	],
	eyes: [
		{ value: 'default', label: 'Звичайні' },
		{ value: 'happy', label: 'Радісні' },
		{ value: 'surprised', label: 'Здивовані' },
		{ value: 'side', label: 'Косі' },
		{ value: 'squint', label: 'Суворі' },
		{ value: 'wink', label: 'Підморгування' },
		{ value: 'winkWacky', label: 'Жартівливі' },
		{ value: 'close', label: 'Закриті' },
		{ value: 'cry', label: 'Сльози' },
		{ value: 'dizzy', label: 'Запаморочення' },
		{ value: 'roll', label: 'Закочені' },
		{ value: 'hearts', label: 'Серця' },
	],
	eyebrow: [
		{ value: 'default', label: 'Звичайні' },
		{ value: 'angry', label: 'Суворі' },
		{ value: 'flat', label: 'Пласкі' },
		{ value: 'raised', label: 'Підняті' },
		{ value: 'sad', label: 'Сумні' },
		{ value: 'unibrow', label: 'Моноброва' },
		{ value: 'up', label: 'Вгору-вниз' },
	],
	mouth: [
		{ value: 'smile', label: 'Посмішка' },
		{ value: 'default', label: 'Нейтрально' },
		{ value: 'serious', label: 'Серйозно' },
		{ value: 'concerned', label: 'Занепокоєння' },
		{ value: 'disbelief', label: 'Невіра' },
		{ value: 'eating', label: 'Їсть' },
		{ value: 'grimace', label: 'Гримаса' },
		{ value: 'sad', label: 'Сумно' },
		{ value: 'scream', label: 'Крик' },
		{ value: 'tongue', label: 'Язик' },
		{ value: 'twinkle', label: 'Весело' },
		{ value: 'vomit', label: 'Нудить' },
	],
};

const legacyHairToTop = (hair) => {
	switch (hair) {
		case 'none':
			return 'noHair';
		case 'short':
			return 'shortHair';
		case 'long':
		case 'bun':
			return 'longHair';
		default:
			return null;
	}
};

const legacySkinToNew = (skin) => {
	switch (skin) {
		case 'light':
			return 'light';
		case 'medium':
			return 'brown';
		case 'dark':
			return 'darkBrown';
		default:
			return null;
	}
};

const legacyEyesToNew = (eyes) => {
	switch (eyes) {
		case 'normal':
			return 'default';
		case 'happy':
			return 'happy';
		case 'angry':
			return 'squint';
		case 'tired':
			return 'default';
		default:
			return null;
	}
};

const legacyMouthToNew = (mouth) => {
	switch (mouth) {
		case 'smile':
			return 'smile';
		case 'neutral':
			return 'default';
		case 'serious':
			return 'serious';
		default:
			return null;
	}
};

const mapLegacyDna = (dna = {}) => {
	if (!('bg' in dna) && !('hair' in dna) && !('accessory' in dna)) {
		return dna;
	}

	const mapped = { ...dna };
	mapped.style = 'circle';
	if (dna.bg === 'gradient') {
		mapped.bgColor = 'lavender';
	} else if (dna.bg === 'solid') {
		mapped.bgColor = 'blue';
	}

	const legacySkin = legacySkinToNew(dna.skin);
	if (legacySkin) {
		mapped.skin = legacySkin;
	}

	const legacyTop = legacyHairToTop(dna.hair);
	if (legacyTop) {
		mapped.top = legacyTop;
	}

	if (dna.hairColor) {
		mapped.hairColor = dna.hairColor;
	}

	const legacyEyes = legacyEyesToNew(dna.eyes);
	if (legacyEyes) {
		mapped.eyes = legacyEyes;
	}

	const legacyMouth = legacyMouthToNew(dna.mouth);
	if (legacyMouth) {
		mapped.mouth = legacyMouth;
	}

	if (dna.accessory === 'glasses') {
		mapped.accessories = 'round';
	}

	if (dna.accessory === 'beard') {
		mapped.facialHair = 'light';
		mapped.facialHairColor = mapped.hairColor || AVATAR_DEFAULT_DNA.facialHairColor;
		mapped.accessories = 'none';
	}

	if (dna.accessory === 'none') {
		mapped.accessories = 'none';
	}

	return mapped;
};

const pickAllowed = (value, allowed, fallback) => (allowed.includes(value) ? value : fallback);

export const normalizeAvatarDna = (dna = {}) => {
	const mapped = mapLegacyDna(dna);
	const normalized = {
		...AVATAR_DEFAULT_DNA,
		...mapped,
	};

	if (mapped.topChance === 0) {
		normalized.top = 'noHair';
	}
	if (mapped.accessoriesChance === 0) {
		normalized.accessories = 'none';
	}
	if (mapped.facialHairChance === 0) {
		normalized.facialHair = 'none';
	}

	Object.keys(AVATAR_OPTIONS).forEach((key) => {
		const allowed = AVATAR_OPTIONS[key].map((item) => item.value);
		normalized[key] = pickAllowed(normalized[key], allowed, AVATAR_DEFAULT_DNA[key]);
	});

	return normalized;
};

export const buildAvatarOptions = (dna = {}) => {
	const normalized = normalizeAvatarDna(dna);
	const options = { ...normalized, mode: 'include', style: 'transparent' };

	if (normalized.top === 'noHair') {
		options.top = AVATAR_DEFAULT_DNA.top;
		options.topChance = 0;
	} else {
		options.topChance = 100;
	}

	if (normalized.accessories === 'none') {
		options.accessories = 'round';
		options.accessoriesChance = 0;
	} else {
		options.accessoriesChance = 100;
	}

	if (normalized.facialHair === 'none') {
		options.facialHair = 'light';
		options.facialHairChance = 0;
	} else {
		options.facialHairChance = 100;
	}

	return options;
};
